import React from "react";
import { modalActions } from "../../../context/actions/modalActions";
import useStore from "../../../context/useStore";

const Modal = () => {
  const [state, dispatch] = useStore();
  const actions = modalActions(state, dispatch);
  const modalProps = state.modal;

  return (
    <div
      onClick={() => {
        actions.updateModal({ isOpen: false });
      }}
      className="position-fixed w-100 h-100 align-items-center justify-content-center"
      style={{
        display: modalProps.isOpen ? "flex" : "none",
        top: 0,
        left: 0,
        background: "rgb(0 0 0 / 54%)",
        zIndex: "99",
        overflowY: "auto",
      }}
    >
      <div
        onClick={(e) => e.stopPropagation()}
        className={
          "position-fixed bg-white p-5 " +
          (modalProps.isOpen ? "animated zoomIn faster" : "")
        }
        style={{
          zIndex: "99",
          top: 0,
          width: "94%",
          height: "97%",
          maxWidth: "400",
          overflowY: "auto",
          ...(modalProps.style || {}),
        }}
      >
        {modalProps.content}

        <div
          className="d-center"
          style={{
            position: "absolute",
            top: 0,
            right: 0,
            padding: 10,
            borderRadius: "100%",
          }}
        >
          {modalProps.actions}
          <button
            onClick={() =>
              actions.updateModal({ isOpen: false, content: null })
            }
            className="btn btn-default bg-white w-100"
          >
            <i className="fa fa-times" />
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;
